import { render, staticRenderFns } from "./WhoIsChampionLA.vue?vue&type=template&id=466a974a&scoped=true&"
import script from "./WhoIsChampionLA.vue?vue&type=script&lang=js&"
export * from "./WhoIsChampionLA.vue?vue&type=script&lang=js&"
import style0 from "./WhoIsChampionLA.vue?vue&type=style&index=0&id=466a974a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466a974a",
  null
  
)

export default component.exports